<template lang="">
  <div>
    <page-header
      left-side-class="col-12 col-md-7"
      :page="headerConfig"
      right-side-class="col-12 col-md-5"
      class="mt-3 mt-md-0"
      @onReturn="() => $router.back()"
      :has-return="true"
    />
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="teachersForStudentsFilter"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="butn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>
<script>
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';

import AcademicYearServices from '@/services/api/academicyear.api';
import LocationServices from '@/services/api/location.api';
import ReportServices from '@/modules/report/api';
import DocumentServices from '@//modules/report/document';

export default {
  name: 'TeachersForStudentsMain',
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => ({
    model: {
      search: {
        collections: {
          academicYears: [],
          centers: [],
          regions: [],
          municipalities: [],
          schools: [],
        },
        filters: {
          academicYear: null,
          center: null,
          region: null,
          municipality: null,
          school: null,
        },
      },
    },
  }),
  computed: {
    headerConfig() {
      return {
        title: 'Estudiantes por Alternativas',
        icon: 'fas fa-file-invoice pr-0 font-22 magnifying-glass-icon-m ',
        routes: ['Inicio', 'Estudiantes por Alternativas'],
      };
    },
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'description',
          placeholder: 'Año Académico',
          error: 'El año académico es requerido.',
          validations: 'required',
          class: 'col-12 col-md-3',
          clearable: false,
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYear,
          onChanged: this.onChangeAcademicYear,
        },
        {
          name: 'center',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'CSEE',
          class: 'col-12 col-md-2',
          options: this.model.search.collections.centers,
          value: this.model.search.filters.center,
          disabled: this.model.search.collections.centers.length == 1,
          onChanged: this.getRegion,
        },
        {
          name: 'region',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Región',
          clearable: false,
          class: 'col-12 col-md-2',
          options: this.model.search.collections.regions,
          value: this.model.search.filters.region,
          disabled: this.model.search.collections.regions.length == 1,
          onChanged: this.getMunicipalities,
        },
        {
          name: 'municipality',
          component: 'custom-drop-down',
          options: this.model.search.collections.municipalities,
          placeholder: 'Municipio',
          fieldName: 'name',
          fieldKey: 'id',
          onChanged: this.getSchools,
          value: this.model.search.filters.municipality,
          class: 'col-12 col-md-2',
          disabled: this.model.search.collections.municipalities.length == 1,
        },
        {
          name: 'school',
          component: 'custom-drop-down',
          options: this.model.search.collections.schools,
          value: this.model.search.filters.school,
          placeholder: 'Escuela',
          fieldName: 'name',
          fieldKey: 'id',
          onChanged: this.onChangedSchool,
          class: 'col-12 col-md-2',
          disabled: this.model.search.collections.schools.length == 1,
        },
      ];
    },
  },
  async mounted() {
    await this.getInitialFilters();
  },
  methods: {
    async getInitialFilters() {
      this.model.search.collections.academicYears = (
        await AcademicYearServices.getCurrentYearAcademicYears()
      ).data;
    },
    async onChangeAcademicYear() {
      await this.getCenters();
    },
    async getCenters() {
      await LocationServices.getCenters({
        academicYearId: this.model.search.filters.academicYear.id,
      }).then((res) => {
        this.model.search.collections.centers = res.data;
        if(this.model.search.collections.centers.length == 1) {
          this.model.search.filters.center = this.model.search.collections.centers[0];
          this.getRegion();
        }
      });
    },
    async getRegion() {
      await LocationServices.getRegions({
        academicYearId: this.model.search.filters.academicYear?.id,
        centerId: this.model.search.filters.center?.id,
      }).then(({ data }) => {
        this.model.search.collections.regions = data;
        if(this.model.search.collections.regions.length == 1) {
          this.model.search.filters.region = this.model.search.collections.regions[0];
          this.getMunicipalities();
        }
      });
    },
    async getMunicipalities() {
      await LocationServices.getMunicipalities({
        academicYearId: this.model.search.filters.academicYear?.id,
        centerId: this.model.search.filters.center?.id,
        regionId: this.model.search.filters.region?.id,
      }).then((res) => {
        this.model.search.collections.municipalities = res.data;
        if(this.model.search.collections.municipalities.length == 1) {
          this.model.search.filters.municipality = this.model.search.collections.municipalities[0];
          this.getSchools();
        }
      });
    },
    async getSchools() {
      await LocationServices.getSchools({
        academicYearId: this.model.search.filters.academicYear?.id,
        centerId: this.model.search.filters.center?.id,
        regionId: this.model.search.filters.region?.id,
        municipalityId: this.model.search.filters.municipality?.id,
      }).then((res) => {
        this.model.search.collections.schools = res.data;
        if(this.model.search.collections.schools.length == 1) {
          this.model.search.filters.school = this.model.search.collections.schools[0];
        }
      });
    },
    async onHandlerSearch() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate();
      if (!isValid) return;
      const payload = {
        academicYearId: this.model.search.filters.academicYear?.id,
        centerId: this.model.search.filters.center?.id,
        regionId: this.model.search.filters.region?.id,
        municipalityId: this.model.search.filters.municipality?.id,
        schoolId: this.model.search.filters.school?.id,
      };
      await ReportServices.getStudentsAlternativesReport(payload).then((res) =>
        DocumentServices.Download(res.data)
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.butn-process {
    right: 15px !important;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
}

</style>
